import * as Yup from "yup";

import { variables } from "../../Variables";

const { required } = variables;

export const addvalidation = Yup.object({
  name: Yup.string()
    .required(required)
    .test("len", "Must be less than 22 characters", (val) => val.length <= 22)
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
  main_type: Yup.string().required(required),
  sub_type: Yup.string().required(required),
  temperature1: Yup.string().required(required),
  temperature2: Yup.string().required(required),
  temperature3: Yup.string().required(required),
  category_id: Yup.string().required(required),
});
